export enum SessionStorageKey {
  AccountSetupViewed = "accountSetupViewed",
  ApplicationAgreementViewed = "applicationAgreementViewed",
  AccountAgreementViewed = "accountAgreementViewed",
  IdVerseReturnPending = "idVerseReturnPending",
  LoyaltyRewardPopupShownForLoanIds = "loyaltyRewardPopupShownForLoanIds",
  IdVerseCompletedCallback = "idVerseCompletedCallback",
}

export interface SessionStorageSchema {
  [SessionStorageKey.AccountSetupViewed]: boolean;
  [SessionStorageKey.ApplicationAgreementViewed]: boolean;
  [SessionStorageKey.AccountAgreementViewed]: boolean;
  [SessionStorageKey.IdVerseReturnPending]: boolean;
  [SessionStorageKey.LoyaltyRewardPopupShownForLoanIds]: number[];
  [SessionStorageKey.IdVerseCompletedCallback]: boolean;
}

export class SessionStorageState {
  static get<K extends SessionStorageKey>(key: K): SessionStorageSchema[K] | null {
    try {
      const value = sessionStorage.getItem(key);

      if (value === null) {
        return null;
      }

      return JSON.parse(value) as SessionStorageSchema[K];
    } catch {
      return null;
    }
  }

  static set<K extends SessionStorageKey>(key: K, value: SessionStorageSchema[K]): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  static remove<K extends SessionStorageKey>(key: K): void {
    sessionStorage.removeItem(key);
  }
}
